export default __webpack_public_path__ + "static/media/blob_red_2.7637b32d.svg";